export default "/assets/images/accessory-img-01.jpg?2dd4d0b66cb5b42f815a67eb6a677156";